import { makeStyles } from '@material-ui/core/styles';

export default makeStyles({
  table: {
    minWidth: 650
  }
});
